<template>
  <div class="exam-details">
    <el-card>
      <h2>考试情况</h2>

      <!-- 搜索栏 -->
      <el-form :inline="true" class="search-bar">



        <!-- 学员姓名下拉框 -->
        <el-form-item>
          <el-select
              v-model="filters.selectedUser"
              placeholder="请选择学员"
              clearable
              style="width: 200px"
          >
            <el-option
                v-for="user in users"
                :key="user.value"
                :label="user.label"
                :value="user.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <!-- 培训计划下拉框 -->
        <el-form-item>
          <el-select
              v-model="filters.selectedPlan"
              placeholder="请选择培训计划"
              clearable
              style="width: 200px"
          >
            <el-option
                v-for="plan in plans"
                :key="plan.value"
                :label="plan.label"
                :value="plan.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <!-- 搜索按钮 -->
        <el-form-item>
          <el-button type="primary" @click="fetchExamDetails">搜索</el-button>
        </el-form-item>
      </el-form>

      <!-- 考试详情表格 -->
      <el-table :data="examDetails.records" border style="width: 100%">
        <el-table-column prop="planName" label="培训计划" width="200"></el-table-column>
        <el-table-column prop="name" label="学员姓名" width="150"></el-table-column>
        <el-table-column prop="score" label="考试分数" width="120"></el-table-column>
        <el-table-column prop="status" label="考试状态" width="120">
          <template #default="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'info'">
              {{ scope.row.status === 1 ? '已完成' : '未完成' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="startDate" label="开始时间" width="180">
          <template #default="scope">
            {{ formatDate(scope.row.startDate) }}
          </template>
        </el-table-column>
        <el-table-column prop="endDate" label="结束时间" width="180">
          <template #default="scope">
            {{ formatDate(scope.row.endDate) }}
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
          :current-page="pagination.page"
          :page-size="pagination.size"
          :total="examDetails.total"
          layout="total, prev, pager, next, jumper"
          @current-change="handlePageChange"
      ></el-pagination>
    </el-card>
  </div>
</template>

<script>
import axios from "@/axios";

export default {
  props: {
    userid: {
      type: Number,
      required: true,
    },
    organizationID: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      examDetails: {
        records: [],
        total: 0,
      }, // 考试详情数据
      filters: {
        selectedUser: null, // 学员 ID
        selectedPlan: null, // 培训计划 ID
      },
      pagination: {
        page: 1,
        size: 10,
      },
      users: [], // 学员下拉框选项
      plans: [], // 培训计划下拉框选项
    };
  },
  methods: {
    // 获取考试详情
    fetchExamDetails() {
      const { page, size } = this.pagination;
      const params = {
        userid: this.filters.selectedUser, // 学员 ID
        planid: this.filters.selectedPlan, // 培训计划 ID
        organizationID:this.organizationID,
        page,
        size,
      };

      axios
          .get("/Exam/details", { params })
          .then((response) => {
            const data = response.data;
            this.examDetails = {
              records: data.data,
              total: data.total,
            };

            // 初次加载时提取学员和培训计划下拉框选项
            if (!this.filters.selectedUser && !this.filters.selectedPlan) {
              this.extractDropdownOptions(data.data);
            }
          })
          .catch((error) => {
            console.error("获取考试详情失败:", error);
            this.$message.error("获取考试详情失败！");
          });
    },

    // 提取并去重学员和培训计划选项
    extractDropdownOptions(data) {
      const uniqueUsers = new Set();
      const uniquePlans = new Set();

      data.forEach((item) => {
        uniqueUsers.add(item.userId);
        uniquePlans.add(item.training_plan_id);
      });

      this.users = Array.from(uniqueUsers).map((userId) => {
        const user = data.find((item) => item.userId === userId);
        return { label: user.name, value: userId };
      });

      this.plans = Array.from(uniquePlans).map((planId) => {
        const plan = data.find((item) => item.training_plan_id === planId);
        return { label: plan.planName, value: planId };
      });
    },

    // 分页变化时
    handlePageChange(newPage) {
      this.pagination.page = newPage;
      this.fetchExamDetails();
    },

    // 格式化日期
    formatDate(date) {
      if (!date) return "";
      const d = new Date(date);
      return `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, "0")}-${d
          .getDate()
          .toString()
          .padStart(2, "0")}`;
    },
  },
  created() {
    this.fetchExamDetails();
    console.log(this.userid)
    console.log(this.organizationID)
  },
};
</script>

<style scoped>
.exam-details {
  padding: 20px;
}
.search-bar {
  margin-bottom: 20px;
}
</style>
